import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import CTA from 'Src/components/buttons/CTA';
import { Flex } from 'Src/components/layout/Flex';

import styles from './StepperFooter.module.scss';

interface StepperFooterProps {
  canGoPrev: boolean;
  canGoNext: boolean;
  onPrevRequested: () => void;
  onNextRequested: () => void;
  centerContent?: ReactNode;
  nextLabel?: string;
  prevLoading?: boolean;
  nextLoading?: boolean;
}

const StepperFooter: FC<StepperFooterProps> = ({
  canGoNext,
  canGoPrev,
  centerContent,
  nextLabel = '',
  nextLoading,
  onNextRequested,
  onPrevRequested,
  prevLoading,
}) => {
  const { t } = useTranslation();
  return (
    <Flex className={styles.container} horizontal gap="xs" alignItems="center" justifyContent="space-between">
      <CTA
        disabled={!canGoPrev}
        onClick={onPrevRequested}
        icon={{ position: 'start', name: 'chevron_left' }}
        label={t('labels.back')}
        loading={prevLoading}
      />
      <span> {centerContent} </span>
      <CTA
        color="primary"
        disabled={!canGoNext}
        onClick={onNextRequested}
        icon={{ position: 'end', name: 'chevron_right' }}
        label={nextLabel === '' ? t('labels.next') : nextLabel}
        loading={nextLoading}
      />
    </Flex>
  );
};

export { StepperFooter };
export type { StepperFooterProps };
